const CONFIG_DEFAULTS_DATES = Object.freeze([
    '2026-08-30',
    '2026-08-29',
    '2026-06-25',
    '2026-05-30',
    '2026-01-30',
    '2025-11-30',
    '2025-05-24'
]);
export { CONFIG_DEFAULTS_DATES };
